// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VuejsDialog from 'vuejs-dialog'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import store from './store/store'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueHighCharts from 'vue-highcharts'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(VueHighCharts)
Vue.use(VuejsDialog);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})


Vue.filter('mask', function(value){
  if(!value) return
  if(value.indexOf('@') != -1){
    //Treat value as email
    var emailArr = value.split("@")
    if(emailArr[0].length > 2){
      return (emailArr[0].substr(0,2) + "xxxx@" + emailArr[1])
    }
  }
  else if (!isNaN(parseInt(value)) && ((parseInt(value).toString()).length == 10)) {
    return "xxxxxxx" + value.substr(7)
  }
});

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  var dateArr = value.split(" ")

  // value = new Date(dateArr[0])
  dateArr[0] = dateArr[0].split("-")
  var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  let day = dateArr[0][0],
      month = monthArray[parseInt(dateArr[0][1]) - 1],
      year = dateArr[0][2]
    return day + " " + month + ", " + year + " "
});

Vue.filter('formatTime', function (value) {
  if (!value) return ''
  var dateArr = value.split(" ")
  return dateArr[1]
});
//
// Vue.filter('formatDate', function (value) {
//   if (!value) return ''
//   value = new Date(value)
//   var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
//   let day = value.getDate(),
//       month = monthArray[value.getMonth()],
//       year = value.getFullYear()
//   return day + " " + month + ", " + year
// });

Vue.filter('captialize', function(value){
  if(!value) return ''
  value = value.toLowerCase()
  var letter = value.substr(0, 1)
  var name = value.substr(1, value.length)
  value = letter.toUpperCase() + name
  return value
});


Vue.filter('formatCurrency', function (value) {
  if (!value) return ''

  value = (value).toString()
  var valueArr = value.split(".");
  if(valueArr[1]){
    if(valueArr[1].length == 1){
      valueArr[1]+='0'
    }
    else if(valueArr[1].length > 2){
      valueArr[1] = valueArr[1].substr(0,2)
    }
    return valueArr.join('.')
  }
  else{
    return value + ".00"
  }

});



// WEBPACK FOOTER //
// ./src/main.js